import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import {
  GetModuleRedirectionURL,
  RetrieveSubscription,
} from './subscription.action';
import { SubscriptionService } from '@app/core/Services';

export class SubscriptionStateInfo {
  retrieveSubscriptionList: Array<any>;
  moduleRedirectionURL: string;
}

@State<SubscriptionStateInfo>({
  name: 'subscription',
  defaults: {
    retrieveSubscriptionList: [],
    moduleRedirectionURL: '',
  },
})
@Injectable()
export class SubscriptionState {
  constructor(private subscriptionService: SubscriptionService) {}
  @Selector()
  static getModuleRedirectionURL(state: SubscriptionStateInfo) {
    return state.moduleRedirectionURL ?? '';
  }

  @Action(RetrieveSubscription, { cancelUncompleted: true })
  retrieveSubscription(
    { getState, setState }: StateContext<SubscriptionStateInfo>,
    action: RetrieveSubscription
  ) {
    return this.subscriptionService.retrieveSubscription().pipe(
      tap((res) => {
        const state = getState();
        setState({
          ...state,
          retrieveSubscriptionList: res,
        });
      })
    );
  }

  @Action(GetModuleRedirectionURL)
  getModuleRedirectionURL(
    { getState, setState }: StateContext<SubscriptionStateInfo>,
    action: GetModuleRedirectionURL
  ) {
    return this.subscriptionService
      .getModuleRedirectionURL(
        action.moduleId,
        action.userName,
        action.externalUserGuid
      )
      .pipe(
        tap((res) => {
          const state = getState();
          setState({
            ...state,
            moduleRedirectionURL: res.valueResult,
          });
        })
      );
  }
}
